import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Procedures from "../pages/procedures/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/procedimientos",
    element: <Procedures />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;